import { DeviceTelemetryType } from '@signageos/common-types/dist/Device/Telemetry/DeviceTelemetryType';
import Responsibility from '../../../Feature/Responsibility';
import ManagementCapability from '../../../NativeDevice/Management/ManagementCapability';
import IGetTelemetryProperties from '../Telemetry/IGetTelemetryProperties';
import { createDeviceTelemetrySaga } from '../Telemetry/deviceTelemetrySagas';
import { AssignedRunners } from '../../../Runner/runnerSaga';
import Property from '../../../Property/Property';

export const telemetryRunnerCustomSaga = createDeviceTelemetrySaga(
	DeviceTelemetryType.RUNNER_CUSTOM,
	Responsibility.RUNNERS,
	[ManagementCapability.RUNNERS],
	getRunnerCustomSettings,
);

export function* getRunnerCustomSettings({
	propertyStorage,
}: IGetTelemetryProperties & { propertyStorage: any; managementDriver: any }): any {
	const assignedRunners: AssignedRunners = yield propertyStorage.getValueOrDefault(Property.DEVICE_RUNNERS, {});

	const runnerEntries = Object.entries(assignedRunners);

	if (runnerEntries.length === 0) {
		return [];
	}

	const runnerDataList: { runnerUid: string; version: string; data: object }[] = [];

	for (const [assignmentUid, runner] of runnerEntries) {
		const telemetryDataLocal = window.localStorage.getItem(`runner_${assignmentUid}`);
		if (telemetryDataLocal) {
			const { telemetryData } = JSON.parse(telemetryDataLocal);
			runnerDataList.push({ runnerUid: runner.runnerUid, version: runner.runnerVersion, data: telemetryData });
		}
	}

	return runnerDataList;
}
